import * as React from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { gettext } from "i18n";

export interface CommentWidgetProps {
  title: string;
  content: string;
  fontSize?: number;
  fontColor?: string;
  backgroundColor?: string;
  editMode?: boolean;
  onChange?: (values: {
    title: string;
    content: string;
    fontSize: number;
    fontColor: string;
    backgroundColor: string;
  }) => void;
}

const CommentWidget = ({
  title,
  content,
  fontSize = 14,
  fontColor = "#333333",
  backgroundColor = "#ffffff",
  editMode = false,
  onChange,
}: CommentWidgetProps) => {
  const handleChange = (field: string, value: any) => {
    if (onChange) {
      onChange({
        title,
        content,
        fontSize,
        fontColor,
        backgroundColor,
        [field]: value,
      });
    }
  };

  const renderContent = () => {
    if (editMode) {
      return (
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>{gettext("Content")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              value={content}
              onChange={(e) => handleChange("content", e.target.value)}
              placeholder={gettext("Enter content...")}
            />
          </Form.Group>
          <div className="d-flex gap-3">
            <Form.Group>
              <Form.Label>{gettext("Font size")}</Form.Label>
              <Form.Control
                type="number"
                min={8}
                max={32}
                value={fontSize}
                onChange={(e) =>
                  handleChange("fontSize", Number(e.target.value))
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{gettext("Font color")}</Form.Label>
              <Form.Control
                type="color"
                value={fontColor}
                onChange={(e) => handleChange("fontColor", e.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{gettext("Background")}</Form.Label>
              <Form.Control
                type="color"
                value={backgroundColor}
                onChange={(e) =>
                  handleChange("backgroundColor", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div
            style={{
              fontSize: `${fontSize}px`,
              color: fontColor,
              backgroundColor: backgroundColor,
              padding: "1rem",
              whiteSpace: "pre-wrap",
              marginTop: "1rem",
            }}
          >
            {content}
          </div>
        </Form>
      );
    }

    return (
      <Card className="CommentWidget">
        <Card.Body className="p-0">
          <div
            style={{
              fontSize: `${fontSize}px`,
              color: fontColor,
              backgroundColor: backgroundColor,
              padding: "1rem",
              whiteSpace: "pre-wrap",
              height: "100%",
            }}
          >
            {content}
          </div>
        </Card.Body>
      </Card>
    );
  };

  return renderContent();
};

export default CommentWidget;
